/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Typography } from '@mui/material';
import useStyles from './styles';
import { Row } from '../row';

export default (props) => {
  const { primary, secondary, hideSmallPrimary, ...rest } = props;
  const classes = useStyles();
  return (
    <Typography component={'div'} variant={'body2'} {...rest}>
      <Row>
        <span className={hideSmallPrimary && classes.hideSmall} style={{ fontWeight: 'bold' }}>
          {primary}
        </span>
        {secondary && <>{secondary}</>}
      </Row>
    </Typography>
  );
};
